// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"759c648c","82":"48b9dff5","229":"bd6da1be","413":"71b72474","623":"c3fc4e63","624":"9788f728","820":"4aff0fd4"}[chunkId] + ".js";
};